import { useState } from "react";
import "react-piano/dist/styles.css";
import "components/theme/customPianoStyles.css";
// React
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
// hooks
import useLocales from "hooks/useLocales";
// Component
import MidiNumbers from "pianoGithub/MidiNumbers";
import { orderNote } from "utils/Data";
import { mediaQueryHeight } from "utils/Function";
import {
  getRandomInt,
  randomIntFromInterval,
  concatArray,
} from "utils/Function";
import MultipleSelectChip from "components/materials/MultipleSelectChip";
import SwitchLabel from "components/materials/SwitchLabel";
import PianoShort from "components/piano/PianoShort";
// Material
import { FormGroup, FormControlLabel, Grid, Switch, Box, Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

function PianoWay() {
  const { translate, translateNote } = useLocales();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isXs = useMediaQuery(theme.breakpoints.up("xs"));

  const [chordsSelected, setChordsSelected] = useState([]);
  const [nameKeyChord, setNameKeyChord] = useState([]);
  const [position, setPosition] = useState(4);
  const [jump, setJump] = useState(false);
  const [hide, setHide] = useState(false);

  const [activeNote, setActiveNote] = useState([]);

  const [accord, setAccord] = useState("");

  const buildNumberFromNote = (accord) => {
    const accordNumber = [];
    let numberOctave = position;
    let fn = orderNote.indexOf(accord[0].charAt(0));
    accord.forEach((element) => {
      if (orderNote.indexOf(element.charAt(0)) < fn) {
        numberOctave++;
        fn = 0;
      }
      accordNumber.push(MidiNumbers.fromNote(element + numberOctave));
    });
    return accordNumber;
  };

  const buildChords = () => {
    const chords = concatArray(chordsSelected);
    const accord = chords[getRandomInt(chords.length)];
    if (accord) {
      setAccord(Object.entries(accord)[0][0]);
      setNameKeyChord(Object.entries(accord)[0][1]);
      setActiveNote(buildNumberFromNote(Object.entries(accord)[0][1]));
    }
    if (jump && accord) {
      setPosition(randomIntFromInterval(2, 5));
    } else setPosition(4);
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-end"
      alignItems="stretch"
      sx={{ pb: "96px" }}
    >
      <Grid item>
        <h1
          style={{
            fontSize: "xxx-large",
            textAlign: "center",
            minHeight: "72px",
          }}
        >
          {translateNote(accord)}
        </h1>
      </Grid>
      <Grid item height={mediaQueryHeight(isMd, isSm, isXs)}>
        <PianoShort
          hide={hide}
          activeNote={activeNote}
          nameKeyChord={nameKeyChord}
          translateNote={translateNote}
          buildChords={buildChords}
        />
      </Grid>
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ pt: "24px" }}
      >
        <Grid item xs={3} sm={6} md={4}>
          <MultipleSelectChip setChordsSelected={setChordsSelected} />
        </Grid>
        <Grid item xs={4} sm={8} md={3}>
          <FormGroup>
            <Box sx={{ textAlign: "center" }}>
              <FormControlLabel
                control={<Switch checked={jump} />}
                onChange={() => setJump(!jump)}
                label={translate("Jump")}
              />
              <Tooltip title={translate("To display chords randomly on the board")} arrow>
                <InfoIcon fontSize="small" />
              </Tooltip>
            </Box>
          </FormGroup>
        </Grid>
        <Grid item xs={4} sm={8} md={3}>
          <SwitchLabel hide={hide} setHide={setHide} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PianoWay;
